import { PageRef } from 'providers/page-ref';

export type RedeemCodePageParams = {};

export const IRedeemCodePage: PageRef<RedeemCodePageParams, void> = {
  pageName: 'RedeemCodePage',
} as PageRef<RedeemCodePageParams, void>;
